/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import Toggler from "./Toggler.container";

export default Toggler;
